<template src="./index.html"></template>
<script>
import data from './data.js';
import comMapping from '../../../../../comMapping';
export default {
	props: {
		title: {
			type: String,
			default: ''
		},
		Preview: {
			type: Boolean,
			default: false
		},
		id: {
			//弹框编辑
			type: String,
			default: ''
		},
		priceall: {
			//票面明细
			type: Array,
			default: function() {
				return [{}, {}, {}, {}, {}, {}, {}, {}];
			}
		},
		srk: {
			//附加内容
			type: Array,
			default: function() {
				return [];
			}
		},
		kaipr: {
			//开票人
			type: String,
			default: ''
		},
		jbrdata: {
			//经办人信息
			type: Object,
			default: function() {
				return {
					xingm: '',
					guoj: '',
					zhengjlx: '',
					bank: '',
					qiybh: ''
				};
			}
		},
		ruleFormb: {
			//购方信息
			type: Object,
			default: function() {
				return {
					customerName: '', //购买方名称
					taxIdentificationNumber: '', //购买方纳税人识别号
					address: '', //购买方地 址、电 话
					zhengjhm: '' //购买方开户行及账号
				};
			}
		},
		ruleFormbxiao: {
			//销方信息 新增也要传
			type: Object,
			default: function() {
				return {
					name: '', //销售方名称
					taxNumber: '', //销售方名称纳税人识别号
					addressPhone: '', //销售方名称地 址、电 话
					bankAccount: '', //销售方名称开户行及账号
					bpayee: '', //收款人
					breview: '', //复 核
					bdrawer: '' //开票人
				};
			}
		},
		stateall: {
			//状态
			type: Object,
			default: function() {
				return {
					istaxincluded: false, //是否含税
					choosetitleindex: '' //发票类型 新增也要传
				};
			}
		},
		totalall: {
			//合计
			type: Object,
			default: function() {
				return {
					pricetotal: '0.00',
					jiastotal: '0.00',
					jiastotalda: '零',
					taxtotal: '0.00'
				};
			}
		},
		bztext: {
			//备注
			type: String,
			default: ''
		},
		tdywxz: {
			//特定业务类型
			type: String,
			default: ''
		},
		danjh: {
			//单据号
			type: String,
			default: ''
		},
		tedxx: {
			//特定信息
			type: Object,
			default: function() {
				return {
					qiybh: '',
					jianzfwfsd: '',
					fasdxxdz: '',
					jianzxmmc: '',
					kuadsbz: '',
					budcdz: '',
					budcxxdz: '',
					zulqqzulqz: ['', ''],
					kuadsbz: '',
					budcqzhm: '',
					mianjdw: ''
				};
			}
		}
	},
	watch: {
		Preview: function(indexVal, oldVal) {
			if (this.tdywxz == '06') {
				this.tedxx.zulqqzulqz=this.tedxx.zulqqzulqz.map(v => {
					console.log(v)
					if (v != null) {
						if (v.length == 8) {
							var reg = /^(\d{4})(\d{2})(\d{2})$/;
							v = v.replace(reg, '$1-$2-$3');
						} else if (v.length == 14) {
							var reg = /^(\d{4})(\d{2})(\d{2})(\d{2})(\d{2})(\d{2})$/;
							v = v.replace(reg, '$1-$2-$3 $4:$5:$6');
						}
					}
					return v
				});
			}
		}
	},
	data() {
		return {
			comMapping: comMapping,
			Data: [{}, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}]
		};
	},
	created() {},
	mounted() {},
	methods: {
		closediagew() {
			this.$emit('closediagew', false);
		}
	}
};
</script>

<style scoped lang="less">
@import url('./index.less');
</style>
